import React from 'react';
import { ErrorMessage, Title, Subtitle, ButtonWrapper, PrimaryButton } from '../styles';

const ErrorView: React.FC = () => {
  return (
    <>
      <ErrorMessage>
        <Title style={{ color: 'inherit', marginBottom: '8px' }}>Phone Number Missing</Title>
        <Subtitle style={{ color: 'inherit', marginBottom: '0' }}>
          Phone number is required for OTP verification. Please go back to login and try again.
        </Subtitle>
      </ErrorMessage>
      
      <ButtonWrapper>
        <PrimaryButton
          type="primary"
          onClick={() => window.history.back()}
          block
        >
          Go Back to Login
        </PrimaryButton>
      </ButtonWrapper>
    </>
  );
};

export default ErrorView;
